module.exports = __webpack_public_path__ + "static/media/send_a_flyer.65f75341.svg";